export const localeMapping: { [key: string]: string } = {
    au: 'en-AU',
    nz: 'en-NZ',
  };

export const localeCountryKey: { [key: string]: string } = {
    au: 'au',
    nz: 'nz',
  };
